<script setup>
import AppIcon from "./AppIcon.vue";
import ButtonComponent from "./ButtonComponent.vue";
const emit = defineEmits(["close-win"]);

const props = defineProps({
  storyData: {
    type: Object,
    required: true,
  },
  edit: {
    type: Object,
    required: true,
  },
});

function validateInterval() {
  if (
    props.storyData.settings.saveInterval.length == 0 ||
    props.storyData.settings.saveInterval < 30
  ) {
    props.storyData.settings.saveInterval = 30;
  }
}

function numbersOnly() {
  props.storyData.settings.saveInterval =
    props.storyData.settings.saveInterval.replace(/[^0-9]/g, "");
}
</script>

<template>
  <div class="basic-window">
    <div class="ui-container">
      <h3>Settings</h3>
      <div class="ui-sub-container">
        <div class="ui-controls">
          <h4>Autosave</h4>
          <div class="bg-vars">
            <div class="link-text-left">
              <div class="ui-label small">Save interval (min 30s)</div>
              <div class="ui-form-textinput">
                <input
                  class="link-input"
                  type="text"
                  @input="numbersOnly"
                  @blur="validateInterval"
                  v-model="storyData.settings.saveInterval"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="ui-controls">
          <h4>Grid</h4>
          <div class="bg-vars">
            <div class="row link-text-left">
              <div class="ui-label small">Snap to grid</div>
              <div class="ui-form-textinput">
                <input
                  class="link-input"
                  type="checkbox"
                  :checked="storyData.settings.snapGrid"
                  v-model="storyData.settings.snapGrid"
                />
              </div>
            </div>
            <div class="row link-text-left">
              <div class="ui-label small">Display grid</div>
              <div class="ui-form-textinput">
                <input
                  class="link-input"
                  type="checkbox"
                  :checked="storyData.settings.displayGrid"
                  v-model="storyData.settings.displayGrid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cornerbutton add">
        <ButtonComponent icon="xmark" color="blue" size="medium" tooltip="Close" @click="$emit('close-win')" />
      </div>
    </div>
  </div>
</template>
